export default {
	how_it_works: 'How it works',
	become_a_tutor: 'Become a tutor',
	// teachOnAirClass: 'Teach on AirClass',
	airClassBlog: 'AirClass Blog',
	our_tutors: 'Our tutors',
	one_on_one: 'AirClass 1-on-1',
	happy_kids: 'Class for kids',
	home: 'Home',
	prices: 'Prices',
	partner: 'Partner with us',
	more: 'More',
	login: 'Login',
	logout: 'Logout',
	app_download: 'App download',
	invite_gift: 'Invite gift',
	invite_friends: 'Invite my friends',
	setting: 'Profile & settings',
	faq: 'FAQs',
	main_home: 'Main home',
	courses: 'Courses',
	profileInfo: 'Profile Info',
	transactionRecord: 'Transaction record',
	remindContent: 'Your next class is scheduled to begin at {time}',
	check: 'Check',
	en: 'English',
	es: 'Español',
	tr: 'Türkçe',
	china: '中文',
	header_line: 'https://web-data.zmlearn.com/image/5uxkd8Hbeig89JbGS9iaRE/img_inviteheadline%402x.png',
};
